import { shallowRef, triggerRef } from "@vue/reactivity";
import { onMounted, onUnmounted } from "@vue/runtime-core";

export const useWindow = () => {
    const $window = shallowRef(window);

    const changeWindow = () => {
        triggerRef($window);
    };

    onMounted(() => {
        window.addEventListener("resize", changeWindow);
        window.addEventListener("scroll", changeWindow);
    });

    onUnmounted(() => {
        window.removeEventListener("resize", changeWindow);
        window.removeEventListener("scroll", changeWindow);
    });

    return { w: $window };
};
